import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useStore } from '@tanstack/react-store'
import { Plus } from 'lucide-react'

import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { Button } from '@/components/ui/button'
import { FeedbackList } from '@/components/feedback/feedback-list'
import { FeedbackSheet } from '@/components/feedback/feedback-sheet'
import { organizationStore } from '@/stores/organization.store'

export const Route = createFileRoute('/_app/_home/feedback')({
  component: FeedbackPage,
})

function FeedbackPage() {
  useBreadcrumbFromRoute()

  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const selectedOrganizationId = useStore(organizationStore, (state) => state.selectedOrganizationId)

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="display-heading text-3xl font-semibold tracking-tight">Feedback</h1>
          <p className="text-muted-foreground mt-1">
            View all user feedback and feature requests
          </p>
        </div>
        <Button onClick={() => setIsSheetOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Add Feedback
        </Button>
      </div>

      <FeedbackList />

      <FeedbackSheet
        organizationId={selectedOrganizationId || ''}
        open={isSheetOpen}
        onOpenChange={setIsSheetOpen}
      />
    </div>
  )
}
